<template>
  <el-dialog visible width="95%" @close="dialogClosed" :append-to-body="true">
    <div
      v-for="(server, i) in getHardwareInfo"
      :key="server.server.id"
      class="server-info"
    >
      <div
        class="server-name"
        @click="serverClick(i)"
        :class="serverErrorClass(server)"
      >
        <i :class="arrowSign(i)"></i>
        {{ server.server.name }}
      </div>
      <div v-if="flags[i]" :key="counter">
        <div v-if="server.error" class="error">{{ server.error }}</div>
        <div v-else>
          <div class="caption">
            <span class="command">df: </span>{{ server.df.caption }}
          </div>
          <el-table
            :data="server.df.data"
            :row-class-name="rowClassName"
            size="small"
          >
            <el-table-column
              v-for="(column, index) in server.df.head"
              :key="index"
              :property="column"
              :label="column"
            ></el-table-column>
          </el-table>
          <div class="caption">
            <span class="command">free: </span>{{ server.free.caption }}
          </div>
          <el-table
            :data="server.free.data"
            :row-class-name="rowClassName"
            size="small"
          >
            <el-table-column
              v-for="(column, index) in server.free.head"
              :key="index"
              :property="column"
              :label="column"
            ></el-table-column>
          </el-table>
          <div class="caption">
            <span class="command">uptime: </span>{{ server.uptime.caption }}
          </div>
          <el-table
            :data="server.uptime.data"
            :row-class-name="rowClassName"
            size="small"
          >
            <el-table-column
              v-for="(column, index) in server.uptime.head"
              :key="index"
              :property="column"
              :label="column"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else :key="counter + 1"></div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      flags: [],
      counter: 0,
    };
  },
  created() {
    this.$store.dispatch("getHardwareInfo").then(() => {
      console.log(this.getHardwareInfo);
      this.getHardwareInfo.forEach(() => this.flags.push(false));
      this.showForm = true;
    });
  },
  methods: {
    rowClassName({ row }) {
      if (row.color === "red") return "error-row";
      if (row.color === "yellow") return "warning-row";
      return "";
    },
    serverErrorClass(server) {
      let result = "";
      for (const command in server) {
        if (command === "server") continue;
        if (command === "error") {
          result = "error";
          break;
        }
        const errorLine = server[command].data.find(
          (line) => line.color === "red"
        );
        const warningLine = server[command].data.find(
          (line) => line.color === "yellow"
        );
        if (errorLine) {
          result = "error";
          break;
        } else if (warningLine) result = "warning";
      }
      return result;
    },
    serverClick(index) {
      this.flags[index] = !this.flags[index];
      this.counter++;
    },
    arrowSign(index) {
      if (this.flags[index]) return "el-icon-caret-bottom";
      else return "el-icon-caret-right";
    },
    dialogClosed() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getHardwareInfo"]),
  },
};
</script>